import { Box, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HomeWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  font-family: 'Gothic A1', sans-serif;
  
  @media (min-width: 900px) {
    svg {
      font-size: 2rem;
    }
  }
`;

export const MenuOptions = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const MenuCard = styled(ButtonBase)`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-radius: 1.2rem;
  border: 1px solid #f0f1f2;
  background: #fff;
  text-align: left;
  width: 100%;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    border-color: rgba(0, 155, 142, 0.3);
    background: #e6f7f5;
  }
`;